import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import imgTemp from "../../assets/landers_temp3.jpeg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "자동 체크인 방법",
    content:
      "랜더스 APP을 통해 예매한 티켓은 입장 검표 시 예매자의 APP 계정으로 자동 체크인 처리됩니다. \n\n - 랜더스 APP 예매 건에 한 해 적용됩니다. \n[SPACE](티켓링크/현장 예매 건 자동 체크인 불가) \n- 선물 받은 티켓의 경우 자동 체크인 시 예매자의 APP 계정으로 적립됩니다. \n- 체크인은 반드시 경기 당일 적립 여부 확인이 필요합니다. \n- 자동 체크인 불가 시 수동 체크인을 이용하여 주시기 바랍니다.",
    reference: "",
  },
  {
    title: "수동 체크인 방법",
    content:
      "자동 체크인이 불가한 경우 수동 체크인을 통해 체크인 적립이 가능합니다. \n\n [ICON:check] 수동 체크인 적립 방법 \n- 랜더스 APP → MY → 체크인 → 수동 체크인 → 티켓 QR코드 or 티켓 번호 입력 \n *가능 시간 : 경기 시작 3시간 전~경기 종료 시 \n\n - 티켓링크/현장 예매 건은 수동 체크인만 가능합니다. \n- 체크인은 경기별로 계정당 1회 가능합니다.\n - 수동 체크인이 불가한 경우 경기 당일 랜더스센터를 방문하여 주시면 직원의 도움을 받으실 수 있습니다. \n[SPACE](랜더스센터 위치 : 경기장 내부 1층 의무실 앞)",
    reference: "",
  },
  {
    title: "체크인 리워드 쿠폰 사용 방법",
    content:
      "적립된 체크인은 횟수 달성에 따라 무료예매권이 지급되며, 랜더스 APP 티켓 예매 시 사용 가능합니다. \n\n [ICON:check]체크인 리워드 쿠폰 사용 방법 \n - 랜더스 APP 예매 → 쿠폰 적용 좌석 선택 → 쿠폰 사용 화면에서 ‘체크인 리워드 쿠폰’ 선택/적용 \n- 체크인 리워드 쿠폰은 예매 1회당 최대 1매 사용 가능합니다.",
    reference:
      "",
  },
  {
    title: "자동 체크인이 되지 않았어요.",
    content:
      "자동 체크인은 랜더스 APP에서 예매한 티켓에 한 해 티켓 검표 시 예매자의 계정으로 자동 적립됩니다. \n\n 티켓링크/현장 예매 건 및 선물 받은 티켓은 수동 체크인을 통해 체크인 적립이 가능합니다. \n\n [ICON:check]수동 체크인 적립 방법 \n- 랜더스 APP → MY → 체크인 → 수동 체크인 → 티켓 QR코드 or 티켓 번호 입력 \n*가능 시간 : 경기 시작 3시간 전~경기 종료 시\n\n- 체크인은 경기 당일에만 가능합니다.\n- 체크인은 경기별로 계정당 1회 가능합니다.\n- 수동 체크인이 불가한 경우 경기 당일 랜더스센터를 방문하여 주시면 직원의 도움을 받으실 수 있습니다.\n[SPACE](랜더스센터 위치 : 경기장 내부 1층 의무실 앞)",
    reference: "",
  },
  {
    title: "리워드 쿠폰이 발급되지 않았어요.",
    content:
      "체크인 적립 충족에 따라 지급되는 체크인 리워드 쿠폰은 리워드 달성 다음날 발급됩니다. \n\n(예시) \n5월 1일 체크인 3회 달성 → 5월 2일 달성 쿠폰 발급\n\n※ 리워드 달성 다음날부터 랜더스 APP 쿠폰함에서 확인 가능합니다.\n※ 달성 다음날에도 쿠폰이 발급되지 않은 경우 랜더스 APP 1:1 문의로 내용 남겨주시면 확인 후 처리 도와드리겠습니다.\n※ 발급된 쿠폰은 예매 1회당 최대 1매 사용 가능합니다.",
    reference: "",
  }
];

const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-center">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => {
  return (
    <AccordionItem
      key={index}
      itemKey={index}
      className="mb-2"
      header={({state}) => 
        <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
          <span
            className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
          >
            Q
          </span>
          {item.title}
        </div>
      }
    >
      {({state}) => 
        <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
          <div className="font-medium text-gray-950">{formatText(item.content)}</div>
        </div>
      } 
    </AccordionItem>
  );
}


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

const CheckinPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };


  return (
    <section className="p-hasHeader">
      <Header title="체크인" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div className="flex justify-center pb-3">
          <img src={imgTemp} alt="체크인" />
        </div>
        <span>SSG랜더스 APP 회원일 경우 경기 관람 후 티켓 인증을 통해 리워드 쿠폰을 획득하실 수 있습니다.</span>
        <ul className="list-disc pl-8">
          <li>멤버십 가입 시 추가 리워드 혜택 이용 가능</li>
          <li>리워드 쿠폰은 정규 시즌 내 사용 가능합니다. (정규 시즌 종료 후 소멸)</li>
          <li>체크인은 경기당 1회 가능합니다.</li>
        </ul>
        <div className="pt-5">
          <div>[체크인 리워드 이용 방법]</div>
          <div>1{")"} SSG랜더스 APP 설치 후 회원가입</div>
          <div>2{")"} APP MY 체크인 메뉴 확인</div>
          <div>3{")"} 당일 경기 티켓 인증 후 체크인 적립</div>
          <div className="pt-5">자세한 사항은 랜더스 APP을 확인해 주세요.</div>
        </div>
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:02-2045-6877"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("티켓예매_전화상담")}
        />
      </div>
    </section>
  );
};

export default CheckinPage;
